import RecommendedJobs from './RecommendedJobs';

export default RecommendedJobs;
